export const columns = ({ sorted, filtered }) => {
  return [
    {
      title: "",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
      sortOrder: sorted.columnKey === "name" && sorted.order,
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      sorter: (a, b) => a.slug.length - b.slug.length,
      sortOrder: sorted.columnKey === "slug" && sorted.order,
    },
    {
      title: "Last Updated On",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date.length - b.date.length,
      sortOrder: sorted.columnKey === "date" && sorted.order,
    }
  ];
};
